import React from 'react';
import './index.css';
import { App } from './App';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { history } from './services/browserHistory';
import './dayjs';
import { I18nProvider } from './i18n';
import { ConfirmDialogProvider } from './components/ConfirmDialogProvider/ConfirmDialogProvider';
import { createRoot } from 'react-dom/client';
import { SYSTEM_ENV } from './constants.ts';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <HistoryRouter history={history}>
      <I18nProvider>
        <ConfirmDialogProvider>
          <App />
        </ConfirmDialogProvider>
      </I18nProvider>
    </HistoryRouter>
  </React.StrictMode>
);

console.info(`SYSTEM_ENV: ${SYSTEM_ENV}, MODE: ${import.meta.env.MODE}`);